import { render, staticRenderFns } from "./recaptcha-attribution.vue?vue&type=template&id=10fe2bae&scoped=true&"
import script from "./recaptcha-attribution.vue?vue&type=script&lang=js&"
export * from "./recaptcha-attribution.vue?vue&type=script&lang=js&"
import style0 from "./recaptcha-attribution.vue?vue&type=style&index=0&id=10fe2bae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe2bae",
  null
  
)

export default component.exports